import { axiosCall } from "./apiRequest";
import { baseUrl } from "./helper";

export const getOrders = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-orders",
      "get",
      "",
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const orderListing = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/order-listing",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const reportOrderApiCall = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/report-issue",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const pushOrderToBorzo = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/push-to-borzo",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const cancelBorzoOrder = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/cancel-borzo-order",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const refreshBorzoOrderStatus = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/refresh-borzo-order-status",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const siensOrderListing = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-siens-orders",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSiensSKUSummaryListing = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-siens-sku-summary",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSiensCardData = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-siens-card-data",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const orderOverview = async ({ start_date, end_date }) => {
  try {
    console.log("satrt date ", start_date, end_date);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const userData = { start_date, end_date };
    const response = await axiosCall(
      baseUrl + "order/order-overview",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const otherStatusOverviewData = async ({
  start_date,
  end_date,
  statusType,
  page,
  limit,
}) => {
  try {
    console.log("satrt date ", start_date, end_date);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const userData = { start_date, end_date, page, limit, statusType };
    const response = await axiosCall(
      baseUrl + "order/other-status-orders-data",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrderDetailsApi = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/order-details",
      "get",
      "",
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrderDeliveryPartnersApi = async ({ startDate, endDate }) => {
  try {
    const token = localStorage.getItem("token");
    const userData = { startDate, endDate };
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/orders-delivery-partner",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrderCourierPartnerApi = async (data) => {
  console.log("data in courier-<<<", data);
  try {
    const token = localStorage.getItem("token");
    const payload = {
      start_date: data?.startDate || "",
      end_date: data?.endDate || "",
    };
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-order-courier-partner",
      "post",
      payload,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getListOfCity_StateForGraph = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/list-of-distinct-state",
      "get",
      "",
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getAnalyticsDataApi = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/analytics-data",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrderCount = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };

    const response = await axiosCall(
      baseUrl + "order/orders-count",
      "post",
      userData,
      header
    );

    return response;
  } catch (error) {
    throw error;
  }
};

export const getAnalyticalGraph = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/analytics-graph",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const sendExcelFile = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/upload-excel-data",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTotalWeekSale = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-totalsales",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateRemittanceApi = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/update-remittance",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getStartDateForRemittance = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-last-remittance-date",
      "get",
      "",
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const dateTimeFormatter = (userdate) => {
  if (!userdate) return "N.A.";
  const date = new Date(userdate);

  // Format the date
  const options = {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  return date.toLocaleString("en-US", options);
};

export const fetchShopifyCheckouts = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/shopify-checkouts",
      "get",
      "",
      header,
      userData
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getBrandWiseSalesApi = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/brand-wise-sales",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPurchaseGrnDataApi = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-purchase-grn-data",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

// export const fetchShopifyCheckouts = async () => {
//   try {
//     const baseUrl = "https://2ebb91-32.myshopify.com/admin/api/2024-10/checkouts.json";
//     const params = {
//       created_at_max: "2024-11-18T07:05:27-02:00"
//     };
//     const headers = {
//       "X-Shopify-Access-Token": "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"
//     };

//     const response = await axios.get(baseUrl, {
//       params,
//       headers
//     });

//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const fetchShopifyAbandonCheckouts = async (userData) => {
  try {
    const token = localStorage.getItem("token");

    // Ensure userData contains the necessary tracking fields
    const { addedToCart, reachedCheckout, sessionConversion } = userData;

    // Construct query parameters
    const queryParams = new URLSearchParams({
      addedToCart: addedToCart || false,
      reachedCheckout: reachedCheckout || false,
      sessionConversion: sessionConversion || false,
    }).toString();

    const header = { Authorization: `Bearer ${token}` };

    // Make API call with query parameters
    const response = await axiosCall(
      `${baseUrl}order/shopify-checkouts?${queryParams}`,
      "get",
      "",
      header
    );

    return response;
  } catch (error) {
    console.error("Error fetching Shopify checkouts:", error);
    throw error;
  }
};

export const getGoogleAnalyticsData = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/shopify-google-analytics",
      "get",
      "",
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDelayedOrders = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/delayed-orders",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDelayInPacking = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/delay-in-packing",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOpenTickets = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/open-tickets",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrderByStatusListing = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-order-by-status",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPendingOtiffOrders = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-pending-otiff-orders",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getCourierOrdersListing = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-order-courier-listing",
      "post",
      userData,
      header
    );
    console.log("data-->>", response);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getTicketsListing = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-tickets-listing",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDatewiseOrdersCount = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/download-orders-count",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrdersListing = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-sales-sku-data",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getRtoData = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-rto-data",
      "post",
      userData,
      header
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getUndeliveredGraphData = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-rto-graph-data",
      "post",
      userData,
      header
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const getRtoLmGraphData = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-rto-lm-graph-data",
      "post",
      userData,
      header
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};
export const getWhatsappData = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-whatsapp-count",
      "get",
      userData,
      header
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const getRtoStatusData = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-rto-status-data",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDelayedSbdOrders = async (userData) => {
  try {
    console.log("payload-->>", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-delayed-sbd-orders",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDelayedData = async (userData) => {
  try {
    console.log("payload", userData);
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-delays-data",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSalesAnalyticsData = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-sales-analytics-data",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getDiscountGraphData = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-discount-graph",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSalesAnalyticsProductList = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-sales-analytics-data",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const kioskOrder = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/kiosk-order-listing",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getKioskSummaryDataMutate = async () => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/kiosk-order-summary",
      "get",
      "",
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getOrderTrackingData = async (userData) => {
  try {
    return await axiosCall(baseUrl + `order/order-detail`, "post", userData);
  } catch (error) {
    throw error;
  }
};


export const kioskSalesSummary = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-kiosk-sales-summary",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const bankPaymentAPi = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-bank-payment-details",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};
export const updatePoDetail = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/update-po-detail",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};



export const updateBankPaymentApi = async (userData) => {
  try {
    const token = localStorage.getItem("token");
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/create-bank-payment",
      "post",
      userData,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getLmPartnerPerformanceApi = async (data) => {
  try {
    const token = localStorage.getItem("token");
    const payload = {
      start_date: data?.startDate || "",
      end_date: data?.endDate || "",
    };
    const header = { Authorization: `Bearer ${token}` };
    const response = await axiosCall(
      baseUrl + "order/get-lm-partner-performance",
      "post",
      payload,
      header
    );
    return response;
  } catch (error) {
    throw error;
  }
};